<template>
  <div id="my">
    <div class="user-profile">
      <div class="my-name">{{ name }}</div>
      <div class="info">
        <van-image round :src="iconPath" />
      </div>
    </div>
    <div class="my-cnt-list">
      <div class="my-cnt-waiting-repair" @click="forwardRepair('agree')">
        <div>{{ waiting_repair_cnt }}</div>
        <div class="waiting-repair-title">待维修</div>
      </div>
      <div class="my-cnt-waiting-repair" @click="forwardRepair('submit')">
        <div>{{ waiting_check_cnt }}</div>
        <div class="waiting-repair-title">待审批</div>
      </div>
      <div class="my-cnt-waiting-repair" @click="forwardRepair('submit_co')">
        <div>{{ waiting_receive_cnt }}</div>
        <div class="waiting-repair-title">待验收</div>
      </div>
    </div>
    <div class="my-setting-list">
      <router-link to="/warranty_list">
        <div class="my-setting-item">
          <div class="my-setting-item-1">
            <img src="@/assets/my-repair.png" alt="img" />
          </div>
          <div class="my-setting-item-2">维修单列表</div>
          <div class="my-setting-item-3">
            <img src="@/assets/my-arrow.png" alt="img"/>
          </div>
        </div>
      </router-link>
      <router-link to="/worker_health_report">
        <div class="my-setting-item">
          <div class="my-setting-item-1">
            <img src="@/assets/my-repair-apply.png" alt="img" />
          </div>
          <div class="my-setting-item-2">健康报告</div>
          <div class="my-setting-item-3">
            <img src="@/assets/my-arrow.png" alt="img"/>
          </div>
        </div>
      </router-link>
      <router-link to="/worker_card">
        <div class="my-setting-item">
          <div class="my-setting-item-1">
            <img src="@/assets/my-repair-apply.png" alt="img" />
          </div>
          <div class="my-setting-item-2">证件上传</div>
          <div class="my-setting-item-3">
            <img src="@/assets/my-arrow.png" alt="img"/>
          </div>
        </div>
      </router-link>
      <router-link to="/worker_identity">
      <div class="my-setting-item">
        <div class="my-setting-item-1">
          <img src="@/assets/my-setting.png" alt="img" />
        </div>
        <div class="my-setting-item-2">身份信息</div>
        <div class="my-setting-item-3">
          <img src="@/assets/my-arrow.png" alt="img"/>
        </div>
      </div>
      </router-link>
      <router-link to="/order_stat">
        <div class="my-setting-item">
          <div class="my-setting-item-1">
            <img src="@/assets/my-stat.png" alt="img" style="width: 18px; height: 18px;  " />
          </div>
          <div class="my-setting-item-2">数据统计</div>
          <div class="my-setting-item-3">
            <img src="@/assets/my-arrow.png" alt="img"/>
          </div>
        </div>
      </router-link>
      <div class="my-setting-item" v-if="show_check_reim" @click="forwardCheckReimbursement">
        <div class="my-setting-item-1">
          <img src="@/assets/my-stat.png" alt="img" style="width: 18px; height: 18px;  " />
        </div>
        <div class="my-setting-item-2">报销审批</div>
        <div class="my-setting-item-3">
          <img src="@/assets/my-arrow.png" alt="img"/>
        </div>
      </div>
      <router-link to="/order_calendar">
        <div class="my-setting-item">
          <div class="my-setting-item-1">
            <img src="@/assets/my-stat.png" alt="img" style="width: 18px; height: 18px;  " />
          </div>
          <div class="my-setting-item-2">工程日历</div>
          <div class="my-setting-item-3">
            <img src="@/assets/my-arrow.png" alt="img"/>
          </div>
        </div>
      </router-link>
      <router-link to="/chat">
        <div class="my-setting-item">
          <div class="my-setting-item-1">
            <img src="@/assets/my-stat.png" alt="img" style="width: 18px; height: 18px;  " />
          </div>
          <div class="my-setting-item-2">问答</div>
          <div class="my-setting-item-3">
            <img src="@/assets/my-arrow.png" alt="img"/>
          </div>
        </div>
      </router-link>
    </div>
    <div class="my-setting-logout" v-if="showLogout" @click="logout">
      <div class="my-setting-item-1">
        <img src="@/assets/my-logout.png" alt="img" />
      </div>
      <div class="my-setting-item-2">退出登入</div>
    </div>
  </div>
</template>

<script>
import {logout} from '@/api/user'
import {getCountNum} from "../../api/user";
import cookies from "vue-cookies";
import {isMobile} from "../../utils/util";

export default {
  name: 'my',
  data() {
    return {
      waiting_repair_cnt: 0,
      waiting_check_cnt: 0,
      waiting_receive_cnt: 0,
      name: '',
      iconPath: 'https://img.yzcdn.cn/vant/cat.jpeg',
      showLogout: true,
      show_check_reim: true,
    }
  },
  created() {
    if (localStorage.getItem('name')) {
      this.name = localStorage.getItem('name')
    }
    this.countNum()
    if (this.isWechat()) {
      this.showLogout = false
    }
    if (this.$store.getters.info && typeof this.$store.getters.info.approve_reim !== 'undefined') {
      this.show_check_reim = this.$store.getters.info.approve_reim
    }
  },
  methods: {
    isMobile() {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    },
    forwardCheckReimbursement() {
      if (isMobile()) {
        this.$router.push({path: '/order_reimbursement_check'})
      } else {
        this.$router.push({path: '/order_reimbursement_check_pc'})
      }
    },
    countNum() {
      getCountNum().then((res) => {
        console.log('res.....', res.data.data)
        if (res.data.data) {
          this.waiting_repair_cnt = res.data.data.wait_maintain
          this.waiting_check_cnt = res.data.data.wait_approve
          this.waiting_receive_cnt = res.data.data.wait_check
        }
      })
    },
    isWechat () {
      let ua = window.navigator.userAgent.toLowerCase()
      return ua.indexOf('micromessenger') !== -1
    },
    forwardRepair(status) {
      this.$router.push({path: '/warranty_list', query: {status: status}})
    },
    logout() {
      logout().then((res) => {
        if (res.data.code === 0) {
          cookies.remove('token')
          localStorage.removeItem('token')
          localStorage.removeItem('history_url')
          this.$router.push('/')
        }
      })
    },
    forwardInfo() {
      this.$router.push('/user_info')
    }
  }
}
</script>

<style scoped>
#my {
  width: 90%;
  margin: 10px auto;
}
.user-profile {
  width: 100%;
  height: 100px;
  display: block;
  overflow: hidden;
}
.my-name {
  float: left;
  font-size: 20px;
  line-height: 100px;
  color: #000000;
}
.my-cnt-list {
  overflow: hidden;
}
.my-cnt-waiting-repair {
  float: left;
  width: 20%;
}
.my-setting-list {
  overflow: hidden;
  margin: 30px auto 20px;
}
.my-setting-item {
  overflow: hidden;
  height: 60px;
  line-height: 60px;
  border-bottom: solid 1px #F3F3F3;
}
.my-setting-logout {
  overflow: hidden;
  cursor: pointer;
  height: 60px;
  line-height: 60px;
}
.my-setting-item-1, .my-setting-item-2 {
  float: left;
}
.my-setting-item-1 {
  margin-right: 10px;
  height: 60px;
  line-height: 68px;
}
.my-setting-item-2 {
  font-size: 16px;
  color: #131921;
}
.my-setting-item-3 {
  float: right;
}
p{
  margin: 0;
  text-align: center;
}
.waiting-repair-title {
  font-size: 12px;
}
.info {
  padding: 20px;
  float: right;
}
.van-tag {
  background: #fff;
  color: #3296fa;
}
.van-image{
  width: 64px;
  height: 64px;
}
.user-group {
  margin-bottom: 15px;
}
.user-links {
  padding: 15px 0;
  font-size: 12px;
  text-align: center;
  background-color: #fff;
}
.van-icon {
  display: block;
  font-size: 24px;
  padding-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/user/my.vue